import tvView from '../views/tvView.vue'
import home from '../views/home.vue'
import dlView from '../views/dlView.vue'
import sh from '../views/sh.vue'

const routers = [

  {
    path: '/',
    redirect: '/tv'
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/tv',
    name: 'tv',
    component: tvView
  },
  {
    path: '/dlView',
    name: 'dlView',
    component: dlView
  },
  {
    path: '/sh',
    name: 'sh',
    component: sh
  }
]

export default routers
